import { apolloClient } from '~/apollo-client';
import { LDClient, LDFlags } from '~/providers';
import { EnrollmentDataSource } from '~/typings/context';
import {
  Flex_FetchEnrollmentOptionsQuery,
  Flex_FetchEnrollmentOptionsQueryVariables,
} from '~/typings/graphql';
import { FETCH_ENROLLMENT_OPTIONS } from './fetch-enrollment-option.queries';

// higher == more preferential
/* eslint-disable camelcase */
const order: Record<EnrollmentDataSource, number> = {
  utility_connect: 4,
  partner_provided: 3,
  bill_capture: 2,
  none: 1,
};
/* eslint-disable camelcase */

export const fetchEnrollmentOptions = async (
  params: FetchEnrollmentOptionsParams,
): Promise<FetchEnrollmentOptionsResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchEnrollmentOptionsQuery,
    Flex_FetchEnrollmentOptionsQueryVariables
  >({
    query: FETCH_ENROLLMENT_OPTIONS,
    variables: { utilityId: params.utilityId },
  });

  const enrollmentOptions = data.enrollmentOptions
    .map(option => option.name as EnrollmentDataSource)
    .sort((a, b) => (order[b] || 0) - (order[a] || 0));

  if (params.preference && enrollmentOptions.includes(params.preference)) {
    return { enrollmentOptions: [params.preference] };
  } else if (params.limit) {
    return { enrollmentOptions: enrollmentOptions.slice(0, params.limit) };
  } else if (
    !(
      enrollmentOptions.includes('partner_provided') &&
      LDClient.variation(LDFlags.showFallbackButton)
    )
  ) {
    /**
     * The decision to include partner_provided is based on the following truth table:
     * |-----|-----|------------------------------|
     * | EP  | LD  |            Result            |
     * |-----|-----|------------------------------|
     * |--T--|--T--|---enable partner_provided----|
     * |--T--|--F--|---disable partner_provided---|
     * |--F--|--T--|---disable partner_provided---|
     * |--F--|--F--|---disable partner_provided---|
     * |-----|-----|------------------------------|
     *
     * */
    return { enrollmentOptions: enrollmentOptions.filter(option => option !== 'partner_provided') };
  } else {
    return { enrollmentOptions };
  }
};

export interface FetchEnrollmentOptionsParams {
  preference?: EnrollmentDataSource;
  limit?: number;
  utilityId: number;
  funnelId?: string;
}

export interface FetchEnrollmentOptionsResponse {
  enrollmentOptions: EnrollmentDataSource[];
}
